'use client';

import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { getAppConfig } from '@bts-web/core-app-config';
import { VerificationLinkButton } from '../../MainTradeVerificationLinkButton/MainTradeVerificationLinkButton';
import { TradeInnerTranslatedValues } from '../../types';
// Legacy-only hook. See trade/AccepBackwardsCompatibilityInterceptor/legacy-freeze/README.md
import { useSetLegacyPendingOrderFlowKey } from '../../legacy-freeze/useSetLegacyPendingOrderFlowKey';

export const OrderVerificationLinkForm = ({
  isDataLoading,
  translations,
  verifyLink,
  isBpfs,
}: {
  isDataLoading: boolean;
  translations: Pick<
    TradeInnerTranslatedValues,
    'startPushTan' | 'authenticationRequiredTitle'
  >;
  verifyLink: string;
  isBpfs: boolean;
}) => {
  const { t } = useClientTranslation();

  const { partnerHostAppName } = getAppConfig();

  const { isLegacyCookieReady } = useSetLegacyPendingOrderFlowKey();

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        paddingTop: 'large',
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small_2',
          alignItems: 'center',
        })}
      >
        <h3
          className={css({
            fontSize: 'headline.small_medium',
            fontWeight: 'headline.small_medium',
            lineHeight: 'headline.small_medium',
            color: 'neutrals.text_primary',
          })}
        >
          {translations.authenticationRequiredTitle}
        </h3>
        <span
          className={css({
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            lineHeight: 'body.medium',
            color: 'neutrals.text_secondary',
            textAlign: 'center',
          })}
        >
          {t('authentication_required_subtitle', {
            name: partnerHostAppName,
          })}
        </span>
      </div>

      <VerificationLinkButton
        isDataLoading={isDataLoading || !isLegacyCookieReady}
        verifyButtonText={translations.startPushTan}
        verificationLink={verifyLink}
        isBpfs={isBpfs}
      />
    </div>
  );
};
